import { NavLink, useLocation } from "react-router-dom";
import { House, Path, Ticket, User, SteeringWheel, Car } from "@phosphor-icons/react";
import { useAuth } from "../lib/auth";

const ITEMS = [
  { to: "/", label: "Accueil", icon: House, exact: true },
  { to: "/trajets", label: "Trajets", icon: Path },
  { to: "/reservations", label: "Réservations", icon: Ticket, auth: true },
  { to: "/compte", label: "Compte", icon: User, auth: true },
];

// Chauffeur : uniquement ses onglets, jamais ceux du client
const DRIVER_ITEMS = [
  { to: "/chauffeur", label: "Accueil", icon: House, exact: true, testid: "accueil" },
  { to: "/chauffeur/courses", label: "Mes courses", icon: SteeringWheel, testid: "mes-courses" },
  { to: "/chauffeur/locations", label: "Mes locations", icon: Car, testid: "mes-locations" },
  { to: "/compte", label: "Compte", icon: User, testid: "compte" },
];

export default function BottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#F9F6F0]/95 backdrop-blur-xl border-t border-[#E8E5DF] safe-bottom"
      data-testid="bottom-nav"
      aria-label="Navigation principale"
    >
      <div className="grid grid-cols-4 h-16">
        {(user?.role === "driver" ? DRIVER_ITEMS : ITEMS).map(({ to, label, icon: Icon, exact, auth, testid }) => {
          const target = auth && !user ? `/login?next=${encodeURIComponent(to)}` : to;
          return (
            <NavLink
              key={to}
              to={target}
              end={exact}
              data-testid={`bottom-nav-${testid || label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")}`}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 text-[11px] font-semibold transition-colors ${
                  isActive || pathname === to ? "text-[#C85A17]" : "text-[#5C6B64]"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={22} weight={isActive || pathname === to ? "fill" : "regular"} />
                  {label}
                </>
              )}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
